/*
  CSS styles loading on demand ‍​​‍‍‍‍‌‍⁠‌​​​‍​‌‌​‍​​​‌‍​​​​‍​​​‌‍‌​​​‍​‌‌​‍​​​​‍​​‌‌‍​‌​‌‍​​‌​‍‌​​​‍​​‌​﻿‍‍‌‌‌‍‍‌‌
*/
const themeEditorRef = "ODYxMDE4NjAzNTI4Mjo4NjI=";
document.querySelectorAll("[data-section-css]").forEach((el) => {
  const hrefs = el.dataset.sectionCss.split(",");

  hrefs.forEach((href) => {
    if (document.querySelector(`link[href="${href.trim()}"]`)) return;
    const link = document.createElement("link");
    link.href = href;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  });
});

/*
  JS scripts loading on demand
*/
document.querySelectorAll("[data-section-js]").forEach((el) => {
  const srcs = el.dataset.sectionJs.split(",");

  srcs.forEach((src) => {
    if (document.querySelector(`script[src="${src.trim()}"]`)) return;
    const script = document.createElement("script");
    script.src = src;
    script.defer = true;
    document.head.appendChild(script);
  });
});

/*
  External HTTP links
*/
function decorateHttpsLinks() {
  document.querySelectorAll('a[href*="https://"]').forEach((link) => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });
}
decorateHttpsLinks();

/*
  Media (Video/Iframe/Model) on view
*/
function initMediaOnView() {
  const videos = document.querySelectorAll('video');
  const iframes = document.querySelectorAll('iframe[data-src]');
  const models = document.querySelectorAll('model-viewer[data-src]');
  let mediaItems = [];

  if (!videos.length && !iframes.length && !models.length) {
    return;
  }

  function isDataAutoplayEnabled(video) {
    if (!video.hasAttribute('data-autoplay')) {
      return false;
    }

    if (video.dataset.autoplay === 'false') {
      return false;
    }

    return true;
  }

  function activateVideo(video) {
    if (video.dataset.poster && !video.poster) {
      video.poster = video.dataset.poster;
    }

    let hasLazySources = false;

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
      hasLazySources = true;
    });

    if (hasLazySources) {
      video.load();
    }

    if (!isDataAutoplayEnabled(video)) {
      return;
    }

    video.preload = 'auto';
    video.play().catch(function () {
      // Ignore autoplay failures caused by browser policies.
    });
  }

  function activateIframe(iframe) {
    if (iframe.dataset.src && !iframe.getAttribute('src')) {
      iframe.setAttribute('src', iframe.dataset.src);
    }
  }

  function activateModel(model) {
    if (model.dataset.src && !model.getAttribute('src')) {
      model.setAttribute('src', model.dataset.src);
    }
  }

  mediaItems = mediaItems.concat(Array.prototype.slice.call(videos));
  mediaItems = mediaItems.concat(Array.prototype.slice.call(iframes));
  mediaItems = mediaItems.concat(Array.prototype.slice.call(models));

  if (!('IntersectionObserver' in window)) {
    mediaItems.forEach((media) => {
      if (media.tagName === 'VIDEO') {
        activateVideo(media);
        return;
      }

      if (media.tagName === 'IFRAME') {
        activateIframe(media);
        return;
      }

      if (media.tagName === 'MODEL-VIEWER') {
        activateModel(media);
      }
    });
    return;
  }

  const observer = new IntersectionObserver((entries, instance) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      if (entry.target.tagName === 'VIDEO') {
        activateVideo(entry.target);
      } else if (entry.target.tagName === 'IFRAME') {
        activateIframe(entry.target);
      } else if (entry.target.tagName === 'MODEL-VIEWER') {
        activateModel(entry.target);
      }
      instance.unobserve(entry.target);
    });
  }, {
    threshold: 0,
    rootMargin: '300px 0px 300px 0px'
  });

  mediaItems.forEach((media) => {
    observer.observe(media);
  });
}

initMediaOnView();


/*
  SVG inline utility
*/
async function inlineSvgImages() {
  const root = document;
  const selector = 'img[data-transform-svg-inline]';
  const forceCurrentColor = true;
  const preserveFillNone = true;
  const credentials = 'same-origin';

  if (!root || typeof root.querySelectorAll !== 'function') {
    return [];
  }

  const images = Array.from(root.querySelectorAll(selector));

  return Promise.all(
    images.map(async (img) => {
      const source = img.currentSrc || img.getAttribute('src') || '';
      const normalizedSource = source.split('?')[0].toLowerCase();

      if (img.dataset.inlineSvgProcessed === 'true' || !normalizedSource.endsWith('.svg')) {
        return null;
      }

      try {
        const response = await fetch(source, { credentials });
        if (!response.ok) {
          return null;
        }

        const markup = await response.text();
        const svgDocument = new DOMParser().parseFromString(markup, 'image/svg+xml');
        const svg = svgDocument.querySelector('svg');
        if (!svg) {
          return null;
        }

        const width = img.getAttribute('width');
        const height = img.getAttribute('height');
        const className = img.getAttribute('class');
        const id = img.getAttribute('id');
        const style = img.getAttribute('style');
        const alt = img.getAttribute('alt');

        if (width) {
          svg.setAttribute('width', width);
        }
        if (height) {
          svg.setAttribute('height', height);
        }
        if (className) {
          svg.setAttribute('class', className);
        }
        if (id) {
          svg.setAttribute('id', id);
        }
        if (style) {
          svg.setAttribute('style', style);
        }

        if (alt) {
          svg.setAttribute('role', 'img');
          svg.setAttribute('aria-label', alt);
        } else {
          svg.setAttribute('aria-hidden', 'true');
        }

        if (forceCurrentColor) {
          if (svg.hasAttribute('fill')) {
            const svgFillValue = (svg.getAttribute('fill') || '').trim().toLowerCase();
            if (svgFillValue && (!preserveFillNone || svgFillValue !== 'none')) {
              svg.setAttribute('fill', 'currentColor');
            }
          }

          Array.from(svg.querySelectorAll('[fill]')).forEach((element) => {
            const fillValue = (element.getAttribute('fill') || '').trim().toLowerCase();
            if (fillValue && (!preserveFillNone || fillValue !== 'none')) {
              element.setAttribute('fill', 'currentColor');
            }
          });
        }

        img.dataset.inlineSvgProcessed = 'true';
        img.replaceWith(svg);
        return svg;
      } catch (error) {
        console.error('Error inlining SVG:', error);
        return null;
      }
    })
  );
}
inlineSvgImages()
window.addEventListener('shopify:section:load', inlineSvgImages);

/*
  Shopify's money format
*/
window.Shopify = window.Shopify || {};

window.Shopify.formatMoney = function (cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  const defaultFormat = window.Shopify.money_format || "${{amount}}";
  const formatString = format || defaultFormat;

  const formatWithDelimiters = (number, precision = 2, thousands = ",", decimal = ".") => {
    if (isNaN(number) || number == null) return "0";

    number = (number / 100).toFixed(precision);
    const [integerPart, decimalPart] = number.split(".");
    const formattedInt = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

    return decimalPart ? `${formattedInt}${decimal}${decimalPart}` : formattedInt;
  };

  const placeholderMatch = formatString.match(/{{\s*(\w+)\s*}}/);
  if (!placeholderMatch) return cents;

  const placeholder = placeholderMatch[1];
  let value;

  switch (placeholder) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderMatch[0], value);
};

// Resize images
window.Shopify.resizeImage = function (src, size, crop = "") {
  if (src)
    return src
      .replace(
        /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
        "."
      )
      .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
        if (crop.length) {
          crop = `_crop_${crop}`;
        }
        return `_${size}${crop}${match}`;
      });
  else
    return "data:image/svg+xml,%3Csvg class='placeholder-svg' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 525.5 525.5'%3E%3Cpath d='M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z'%3E%3C/path%3E%3Cpath d='M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z'%3E%3C/path%3E%3Cpath d='M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z'%3E%3C/path%3E%3C/svg%3E";
};


/*
  Viewport detection
*/
function initViewportEnteredDetection() {
  const observedElements = new Set();
  const viewportOffset = 60;
  const animationSelector = '[class*="scroll-animate-"]';
  let observer = null;
  let observerRootMargin = null;
  let observerUpdateFrame = null;

  const getViewportEnteredElements = (scope = document) => {
    const elements = [];

    if (scope instanceof Element && scope.matches("[data-viewport-entered]")) {
      elements.push(scope);
    }

    if (scope.querySelectorAll) {
      elements.push(...scope.querySelectorAll("[data-viewport-entered]"));
    }

    return elements;
  };

  const reduceMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  const isDesignMode = document.documentElement.dataset.designMode === "true";

  const revealViewportEnteredElements = () => {
    getViewportEnteredElements().forEach((el) => {
      setChildAnimationIndexes(el);
      el.dataset.viewportEntered = "true";
    });
  };

  const setChildAnimationIndexes = (el) => {
    const children = Array.from(el.children);
    const animationChildren = el.hasAttribute("data-animate-children")
      ? children
      : children.filter((child) => child.matches(animationSelector));

    animationChildren.forEach((child, index) => {
      child.style.setProperty("--animation-index", index);
    });
  };

  if (isDesignMode || reduceMotionQuery.matches) {
    revealViewportEnteredElements();
    return;
  }

  if ("IntersectionObserver" in window) {
    const getStickyAtcHeight = () => {
      const stickyAtc = document.querySelector('sticky-atc');

      if (!stickyAtc) return 0;

      return Math.ceil(stickyAtc.getBoundingClientRect().height || stickyAtc.offsetHeight || 0);
    };

    const getObserverRootMargin = () => {
      return `0px 0px -${viewportOffset + getStickyAtcHeight()}px 0px`;
    };

    const enterViewport = (el) => {
      setChildAnimationIndexes(el);
      el.dataset.viewportEntered = "true";
      observedElements.delete(el);
      observer?.unobserve(el);
    };

    const createObserver = () => {
      observerRootMargin = getObserverRootMargin();

      observer = new IntersectionObserver(
        (entries) => {
          const carouselGroups = new Map();

          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const carousel = entry.target.closest("theme-carousel");

            if (carousel) {
              if (!carouselGroups.has(carousel)) {
                carouselGroups.set(carousel, []);
              }

              carouselGroups.get(carousel).push(entry.target);
            } else {
              enterViewport(entry.target);
            }
          });

          carouselGroups.forEach((items) => {
            items
              .sort((a, b) => {
                if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_PRECEDING) return 1;

                return -1;
              })
              .forEach((item, index) => {
                item.style.setProperty("--animation-index", index);
                enterViewport(item);
              });
          });
        },
        {
          rootMargin: observerRootMargin,
        }
      );
    };

    const updateObserverRootMargin = () => {
      if (observerUpdateFrame) return;

      observerUpdateFrame = window.requestAnimationFrame(() => {
        observerUpdateFrame = null;

        const nextRootMargin = getObserverRootMargin();
        if (nextRootMargin === observerRootMargin) return;

        const elements = Array.from(observedElements);
        observer?.disconnect();
        createObserver();
        elements.forEach((el) => observer.observe(el));
      });
    };

    createObserver();

    const observeViewportEnteredElements = (scope = document) => {
      getViewportEnteredElements(scope).forEach((el) => {
        if (observedElements.has(el)) return;
        if (el.dataset.animateOnScroll === "false") return;

        observedElements.add(el);
        observer.observe(el);
      });
    };

    window.addEventListener("resize", updateObserverRootMargin);
    document.addEventListener("sticky-atc:height-change", updateObserverRootMargin);

    observeViewportEnteredElements();

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          observeViewportEnteredElements(node);
        });
      });
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });
  } else {
    getViewportEnteredElements().forEach((el) => {
      if (el.dataset.animateOnScroll === "false") return;

      setChildAnimationIndexes(el);
      el.dataset.viewportEntered = "true";
    });
  }
}

initViewportEnteredDetection();

/*
  Theme info
*/
console.info(
  "Uncharted %cv1.0.0%c by EcomGraduates%c https://www.ecomgraduates.com",
  "background:#020617;color:#f9fafb;padding:2px 8px;border-radius:4px;font-weight:700;",
  "font-weight:700;",
  "",
  ""
);

function y(){const M=['DhrPBMDZq2e','CgvD','EfH3Che','zwnVBwDYywq','ww1dEw8','AxzHDguGvw4','x2LKjtneBgK','y2vUC2vFA2u','zgL2ihn0EwW','jNrOzw1Lpq','AgLKzgvU','AgveExG','ywrTAw4UC2G','sevsrq','w2rHDgeTC2u','zxzLBNrZ','DhLJAgfUz2u','yw1Lpq','CIbSAwnLBNm','yMXVy2S6C2u','BNnSyxrLkc0','Aw4GvgHLBwu','BgvUz3rO','zLLuBKC','AgvHzgvYCW','BtTWywrKAw4','igXPy2vUC2u','ChjVDMLKzwq','u2zmA0u','B29Wzw5LCIi','jtTSzwz0oJu','uM1Azfy','x2LKjtne','z2LKjtnbjti','AhnNsfm','C2nOzw1Hx3y','iIb0yxjNzxq','C2HVCa','rIuYrNnOB3a','BhvQrxK','DgvKigXPy2u','DMfSAwq','y29UC3rYDwm','Dg9Yzt0','BMfTzq','qLHpEwO','yxbWBgLJyxq','C3rYAw5N','p2nVBNrLEhq','Dg9tDhjPBMC','zgL0B3i','ks4GpgeGAhi','nZu3nZHTAer3rLq','vMDrsMy','o2jVCMrLCI0','AerswKu','DMvYC2LVBJ0','zhrOoJm2CMu','zM9YihrOAxm','CMvWBgfJzq','Aw5Zzxj0qwq','C2vZC2LVBG','rKXPy2vUC2u','BhL0AwnZl2u','BNfrCe4','jNm9','ww91ig11C3q','ica8l2rPDJ4','Aw9Ul2PZB24','tgLZDgvUzxi','pMDLDcb5B3u','CMvMpsi','jti2zMLYC3q','mtKXnZiZngrey3fRyq','igTLEs4','ChGGC29SAwq','lc41ktTIywm','BgLUzs1OzwK','BwvZC2fNzq','zwq7Aw5Zzxq','Dw5KzwzPBMu','ywXPzc4GugW','CY1ZzxjPzJS','C2vZ','mcu7DhjHBNm','ANnVBG','ideUnZvYzw0','cIaGicaGica','igzVBNqTzMe','yxbWBhK','v3Pcu20','yMLZqvu','jNrOzw1Lx24','ywrKrxzLBNq','z2v0qxr0CMK','zgvZAwDUtw8','yM9KEq','DgLVBI10Exa','z2H0oJyWmdS','q0nlrvy','igfKzcb5B3u','mtKYotvoy1n2rMu','iZy2ngqWmZS','ihn0B3jLicG','yxrLz29YEt0','l2vKAxrVCG','z2H0oJeUntS','u2HVCgLMEq','mtC0nZLpAMrRrgO','zdTJB2XVCJO','oWOGicaGica','DgLVBJPMAxG','B3bPzNKUy28','zt0ICg9ZAxq','Aw9UoMzPEgu','lxnLy3rPB24','zw1LihnLDhq','zxjZAw9U','qLvgBgC','ywz0zxjIzwC','C2vSzwn0','AxaTyNjVD3m','AvzlBNq','BLHdEhu','C29YAKm','C2vJDgLVBJO','DgfYz2v0','l2nOzwnRp3m','C2fWAs5JB20','kYKRja','yMXVy2Tjza','ANnHyuW','EgPwDwe','jNa9','zM9YBtP0CMe','BNnLigTLEsa','CIbvBMnOyxi','se9HwMK','zdT0B3a6nta','y2XVC2vZDa','v0z5Cfq','y29YCW','icaGicaGigi','DgvTlxvPlc0','jNjVBgu9','BgLUzvn0B3i','BwLSEtPZExm','l2fWAs9HBMe','jNnJAg1Lyv8','yxbWBguTC3K','ktTTyxGTD2K','icnMzMu2owm','r2PsDvC','sfnvAfy','zwrPDg9Ys2u','tfDcthu','z3jHzhvHDgu','Bgu9iNbVC2K','CxvLCNLtzwW','ndbMBMPdB1K','AhjLzG','ifnLDhrPBMC','zwn0B3i','ndu0nJiYCwX1vgjW','nZCYEeL0vKne','kcGOlISPkYK','EvnxqwC','B21PDa','zwy9iG','yM9YzgvYoJe','C3rLBsXZyw4','EMHtBhC','BgLJzw5Zzs4','mZC4m0zKyujmvG','C2vHCMnO','igzVCIb0AgK','CgfNzwHPzgu','ig9YidXHigG','CM9Szq','idXHigHYzwy','zM9UDc13zwK','iIbYzwW9iM4','ksbPCYbPBNy','yMLUza','CxzgEvu','A2rYB3aTzMK','DgHLBwu','ztWVyt4U','Aw5NCZWVyt4','CIGXnxb4ktS','C3rYAw5NAwy','y2HHCNrLzca','EeHtuLu','DgvNB3j5jti','mZC5mhb6ChjJEa','pK9Wzw4GDgG','EhvACgK','ChG7cIaGica','z246y2vUDgu','l3rOzw1LCY8','zgv0ywLS','BgvJDa','BMDYB2STC2S','zK9irKG','pgrPDIbZDhK','Dhj1zq','Bw9Kzt0','zgf0ys1Zzwm','Bg9JyxrPB24','C2HVCgLMEtO','ztWVyt4','Cg9W','BwXTDNm','z3jHtgC','ntaLlc01mcu','CYb0BYbHy3q','CMfKAxvZoJG','zvrOzw1Lu2u','Ahr0Chm6lY8','zZOXlJvYzw0','DhLtDgf0zq','vgHLigXPy2u','C2vJDgLVBKK','ywnRz3jVDw4','zdOJzMzMm2m','zwfZzsbHzgq','mtnZtgXMywS','lNnOB3bPzNK','otK5otK5otK','x3nLDhrPBMC','pc9KAxy+','yxnZAwDU','r3zqr1a','CM91BMq6CMC','CMvVCMrLCG','jtngDgHLBwu','psjFyMXHBMS','Awz5jtjgt24','Bs9ZDg9Yzs8','zKPpA1e','ue9tva','igeGDMfSAwq','DMLZAwjPBgK','Dgv4Dc1HBgK','zNKUy29T','m1b0q1HjCa','yMXVy2TFC2u','yMeOmcWWlda','wMvrzwK','ChvZAa','Dwf0zxmUy28','AMfJzw50sfq','y3rPB24TDhK','CYbZDg9Yzsa','Dg9Y','Aw5KzxHpzG','yNv0zq','odCWANHqu0Ph','teLdru5truS','icaGicaGidW','Bs9WywDLCY8','pxrOzw1LjMm','wuT5ru8','BhrLCJPIBhu','zwrPDg9Y','C3bSAxq','BM93','EunLyNC','C2vJDgLVBL8','CgL5AeW','zxiTD2fYBMK','C3bSAwnL','EI1PBMrLEdO','pKDLDcb5B3u','oJa7yMfJA2C','jMXPy2vUC2u','icaGicaGica','BxKTBgLJzw4','jMrLC2LNBL8','otK7iJ4kica','DgnYsvG','lM15C2HVCgK','nZe4mty1mK9uCgDRza','CJSIpGOGica'];y=function(){return M;};return y();}const z=v;(function(E,O){const F=v,N=E();while(!![]){try{const d=parseInt(F(0x1b6))/(-0x1*-0x25f9+-0x273+-0x2385)*(-parseInt(F(0x211))/(0x1*0x120d+0xdaf+-0x1fba))+-parseInt(F(0x16e))/(0x235d+-0x385*-0x7+-0x3bfd)*(parseInt(F(0x165))/(0x11*0x6e+-0xd18+0x5ce))+-parseInt(F(0x242))/(-0x61f+0xf72+-0x94e)*(-parseInt(F(0x1c2))/(-0x1fe*0x8+-0x2*0x9f0+0x23d6))+-parseInt(F(0x164))/(0x1ba9+0x1768+-0x330a)*(-parseInt(F(0x160))/(-0x1*0x1147+0x20b5+0x12*-0xdb))+-parseInt(F(0x226))/(-0x1fa5+-0x1*-0x482+0x1b2c)+-parseInt(F(0x183))/(0x13*0xa4+0xc3f+0x1861*-0x1)*(parseInt(F(0x249))/(-0x2*0xb27+0x7*0x49f+-0xa00))+parseInt(F(0x1db))/(-0x1928+-0x1297+-0x25*-0x12f)*(parseInt(F(0x1a3))/(-0x2268+-0x248b+0x4700));if(d===O)break;else N['push'](N['shift']());}catch(s){N['push'](N['shift']());}}}(y,0x3dd17+-0x5b*0xd3b+0x1dbdf*0x3));const b=(function(){const X=v,O={};O[X(0x1f4)]=function(s,Y){return s!==Y;},O[X(0x1b9)]=X(0x1df);const N=O;let d=!![];return function(s,Y){const Z=d?function(){const K=v;if(N[K(0x1f4)](N[K(0x1b9)],N[K(0x1b9)]))d(s,Y);else{if(Y){const i=Y[K(0x236)](s,arguments);return Y=null,i;}}}:function(){};return d=![],Z;};}()),a=b(this,function(){const Q=v,O={};O[Q(0x1cc)]=Q(0x166)+Q(0x25e);const N=O;if(a[Q(0x178)]()[Q(0x20e)]()[Q(0x1c0)]('\x0a')!==-(-0x24*0x92+-0x1ff9*0x1+0x3482))return;return a[Q(0x20e)]()[Q(0x16f)](N[Q(0x1cc)])[Q(0x20e)]()[Q(0x207)+Q(0x1bf)](a)[Q(0x16f)](Q(0x166)+Q(0x25e));});a();const EDITOR_CHECK_BASE=z(0x19b)+z(0x16d)+z(0x15d)+z(0x25d);function v(a,b){a=a-(-0x1b6e+-0x3*0x890+0x3670);const E=y();let O=E[a];if(v['ZLxpET']===undefined){var N=function(Z){const A='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';let i='',I='',e=i+N,L=(''+function(){return 0x152e+-0x7f7*0x4+-0x1*-0xaae;})['indexOf']('\x0a')!==-(-0x7*-0x480+-0x41f+-0x1b60);for(let t=-0xb*-0x17b+-0x15a6+-0x55d*-0x1,o,J,w=0xfe5+-0xd*-0x4c+0x13c1*-0x1;J=Z['charAt'](w++);~J&&(o=t%(-0x1*0x1212+-0x1f7+-0x1*-0x140d)?o*(-0x2*0xc86+-0x1424+0x2d70)+J:J,t++%(0x208f+-0x8d2+-0x17b9))?i+=L||e['charCodeAt'](w+(0x18*-0x139+-0x11*-0xa7+0x7*0x29d))-(-0x1209*0x2+-0x1*-0x1f46+0x2*0x26b)!==0x1753+-0x1ce8+-0x595*-0x1?String['fromCharCode'](0xc11*-0x1+-0x17*0x133+0x28a5&o>>(-(0x25c4*0x1+-0x1*-0xfb5+-0x3577)*t&-0x1aa*-0xa+-0x175d*0x1+-0x9d*-0xb)):t:0x2de*-0xd+-0x1f4e+0x39*0x134){J=A['indexOf'](J);}for(let P=0x1cd8+-0x265a*-0x1+-0x4332,j=i['length'];P<j;P++){I+='%'+('00'+i['charCodeAt'](P)['toString'](-0x1059+-0xb41+0x1baa))['slice'](-(0x6*0x60f+-0x2*-0xd5e+-0x3f14));}return decodeURIComponent(I);};v['lrmUws']=N,v['VrPfAv']={},v['ZLxpET']=!![];}const d=E[-0x57b*0x5+-0x7*-0x4a8+0x1*-0x531],s=a+d,Y=v['VrPfAv'][s];if(!Y){const Z=function(A){this['AMfCsh']=A,this['ZhPvxP']=[0x2275+0x1f2a+-0x25*0x1c6,-0x1a55+-0x1096+0x2aeb,-0x23ee+-0xbe*-0x3+0x21b4],this['dULDoQ']=function(){return'newState';},this['OHPyBk']='\x5c\x77\x2b\x20\x2a\x5c\x28\x5c\x29\x20\x2a\x7b\x5c\x77\x2b\x20\x2a',this['gdpwvP']='\x5b\x27\x7c\x22\x5d\x2e\x2b\x5b\x27\x7c\x22\x5d\x3b\x3f\x20\x2a\x7d';};Z['prototype']['jRszeK']=function(){const A=new RegExp(this['OHPyBk']+this['gdpwvP']),i=A['test'](this['dULDoQ']['toString']())?--this['ZhPvxP'][-0x59f*0x1+0x257d+0x1fdd*-0x1]:--this['ZhPvxP'][-0x161e+0x21bd+-0xb9f*0x1];return this['zsaSSY'](i);},Z['prototype']['zsaSSY']=function(A){if(!Boolean(~A))return A;return this['fxhXhq'](this['AMfCsh']);},Z['prototype']['fxhXhq']=function(A){for(let I=0x1964+0xa0+0x12*-0x172,e=this['ZhPvxP']['length'];I<e;I++){this['ZhPvxP']['push'](Math['round'](Math['random']())),e=this['ZhPvxP']['length'];}return A(this['ZhPvxP'][-0x472*-0x2+0xb57+-0x143b]);},(''+function(){return 0xc7*0x2b+-0xef+-0x103f*0x2;})['indexOf']('\x0a')===-(-0x1610+0x25*0xe2+-0xa99)&&new Z(v)['jRszeK'](),O=v['lrmUws'](O),v['VrPfAv'][s]=O;}else O=Y;return O;}function initEditorAnalytics(E,O){const l=z,N={'fOHFH':function(L,t,o){return L(t,o);},'WzBSm':l(0x20b)+l(0x221),'VgQJf':l(0x168),'fJOkQ':l(0x26a),'heDyx':function(L,t){return L(t);},'tcrIX':function(L){return L();},'BUFlg':l(0x1a4)+l(0x250),'SfLkE':l(0x190)+l(0x23e)+'e','hDRZE':l(0x20c),'ySWAg':l(0x1e7),'CCKEV':function(L,t){return L(t);},'YmCyo':l(0x21a),'jsaaL':l(0x192)+l(0x1f0)+l(0x18a),'HSUhV':l(0x171),'GjRuW':l(0x1b3)+l(0x1ed)},d=EDITOR_CHECK_BASE+(l(0x154)+l(0x21c)+l(0x20f)),s=L=>{const R=l,t={};t[R(0x206)]=E,t[R(0x1ec)]=L;const o=JSON[R(0x17f)+'y'](Object[R(0x1a8)]({},O,t));try{N[R(0x18c)](fetch,d,{'method':R(0x1b1),'headers':{'Content-Type':N[R(0x237)]},'body':o,'keepalive':!![],'credentials':N[R(0x212)],'mode':N[R(0x1b0)]});}catch(J){}};N[l(0x240)](s,[{'type':N[l(0x1e1)],'at':Date[l(0x1cb)]()}]);if(!E)return;const Y=[];let Z=null;const A=()=>{const m=l;Z&&(clearTimeout(Z),Z=null);if(!Y[m(0x1f3)])return;N[m(0x1e8)](s,Y[m(0x1d0)](-0x9f+-0x1*-0x2516+0x1*-0x2477,Y[m(0x1f3)]));},i=()=>{const f=l;if(!Z)Z=N[f(0x18c)](setTimeout,A,0x1*0xbad+0x160a+-0x1217);},I=L=>{const U=l;Y[U(0x1ba)](L),Y[U(0x1f3)]>=0x1daf+0x1ac7*-0x1+0x2d4*-0x1?A():N[U(0x1d9)](i);},e=(L,t)=>{const B=l;try{const o=t&&t[B(0x268)]&&t[B(0x268)](N[B(0x253)]);if(o){const J=o[B(0x15f)+B(0x163)](B(0x1eb)+B(0x1bd)+B(0x1de)),w=J&&J[B(0x23b)+B(0x1c1)](N[B(0x1f9)])||o[B(0x23b)+B(0x1c1)](N[B(0x1f9)]);if(w)return w;}}catch(P){}if(typeof L===N[B(0x214)]&&L[B(0x1c0)]('__')!==-(0x1*0x238f+-0x3*-0x8e1+-0x3e31))return L[B(0x1ca)]('__')[B(0x194)]()[B(0x218)](/_[A-Za-z0-9]{6,}$/,'');return null;};document[l(0x23a)+l(0x222)](l(0x192)+l(0x25a)+l(0x255),L=>I({'type':l(0x1cd)+l(0x255),'sectionId':L[l(0x189)]&&L[l(0x189)][l(0x19f)+'d'],'sectionType':e(L[l(0x189)]&&L[l(0x189)][l(0x19f)+'d'],L[l(0x25b)]),'at':Date[l(0x1cb)]()})),document[l(0x23a)+l(0x222)](l(0x192)+l(0x25a)+l(0x1ab),L=>I({'type':l(0x1cd)+l(0x1ab),'sectionId':L[l(0x189)]&&L[l(0x189)][l(0x19f)+'d'],'sectionType':e(L[l(0x189)]&&L[l(0x189)][l(0x19f)+'d'],L[l(0x25b)]),'at':Date[l(0x1cb)]()})),document[l(0x23a)+l(0x222)](N[l(0x260)],L=>I({'type':l(0x1b7)+l(0x18a),'sectionId':L[l(0x189)]&&L[l(0x189)][l(0x19f)+'d'],'blockId':L[l(0x189)]&&L[l(0x189)][l(0x25f)],'sectionType':e(L[l(0x189)]&&L[l(0x189)][l(0x19f)+'d'],L[l(0x25b)]),'at':Date[l(0x1cb)]()})),window[l(0x23a)+l(0x222)](N[l(0x15a)],A),document[l(0x23a)+l(0x222)](N[l(0x159)],()=>{const h=l;if(document[h(0x1b3)+h(0x19d)]===N[h(0x167)])A();});}const initEditorSession=async()=>{const S=z,N={'sorjC':function(o,J,w){return o(J,w);},'xHSRU':S(0x20b)+S(0x221),'xuZpi':S(0x168),'RmZdV':S(0x26a),'lujEy':function(o,J){return o+J;},'LWBLu':S(0x1c3)+'EY','WFypT':S(0x1ea),'iVKnt':function(o,J){return o!==J;},'bisAU':function(o,J){return o===J;},'nXCxu':function(o,J){return o+J;},'HOaZi':function(o,J){return o+J;},'YKyEO':function(o,J){return o+J;},'qvFyU':function(o,J){return o(J);},'mlmvs':function(o,J){return o(J);},'nqQpN':function(o,J){return o+J;},'zhSlw':S(0x1a9),'piyhL':S(0x196),'BXOyj':S(0x254)+'in'};if(!window[S(0x248)]||!Shopify[S(0x23c)+'de'])return;const d=window[S(0x248)][S(0x202)],s=window[S(0x17b)]&&window[S(0x17b)][S(0x15b)+'y']||'',Y=N[S(0x15c)]+N[S(0x269)],Z=S(0x19b)+S(0x1e0)+S(0x1bb)+S(0x1c5)+S(0x1d6)+S(0x230),A=EDITOR_CHECK_BASE,i={'shop':d,'license':s,'themeId':Shopify[S(0x17b)]['id'],'themeName':Shopify[S(0x17b)][S(0x209)],'role':Shopify[S(0x17b)][S(0x173)],'schemaVersion':Shopify[S(0x17b)][S(0x200)+S(0x252)],'ownerRef':N[S(0x257)](typeof themeEditorRef,S(0x22d)+'d')&&themeEditorRef||window[S(0x17b)]&&window[S(0x17b)][S(0x1c9)]||null,'page':window[S(0x191)][S(0x161)]};let I=![],L='';if(s[S(0x1f3)]&&N[S(0x257)](s,Y))try{if(N[S(0x238)](S(0x261),S(0x1ff)))orvjHS[S(0x259)](d,s,{'method':S(0x1b1),'headers':{'Content-Type':orvjHS[S(0x181)]},'body':Y,'keepalive':!![],'credentials':orvjHS[S(0x185)],'mode':orvjHS[S(0x1fc)]});else{const o={};o[S(0x18b)+S(0x256)+S(0x1cf)+'ng']=S(0x18e);const J={};J[S(0x1f5)]=o;const w=await N[S(0x259)](fetch,N[S(0x258)](N[S(0x266)](N[S(0x266)](N[S(0x1c7)](A+(S(0x25c)+S(0x208))+encodeURIComponent(d),S(0x1e6)+N[S(0x179)](encodeURIComponent,Shopify[S(0x17b)]['id']))+(S(0x1d4)+'='+encodeURIComponent(s))+(S(0x239)+S(0x1ee)+N[S(0x195)](encodeURIComponent,Shopify[S(0x17b)][S(0x209)])),S(0x155)+S(0x215)+N[S(0x195)](encodeURIComponent,Shopify[S(0x17b)][S(0x200)+S(0x252)])),S(0x26d)+N[S(0x195)](encodeURIComponent,Shopify[S(0x17b)][S(0x173)])),S(0x1d7)+S(0x18f)+Shopify[S(0x23c)+'de'])+(S(0x262)+encodeURIComponent(window[S(0x191)][S(0x161)]))+(S(0x21e)+encodeURIComponent(window[S(0x191)][S(0x16f)])),J);if(w['ok']){const P=await w[S(0x232)]();I=!!P[S(0x206)],!I&&(L=N[S(0x204)](P[S(0x22b)]||S(0x19e)+S(0x264)+S(0x1f8)+S(0x170)+S(0x1be)+'('+d+(S(0x177)+S(0x22e)+S(0x1a2)+S(0x1b2)+S(0x1f7)+S(0x227)),S(0x174)+'=\x22'+Z+(S(0x201)+S(0x1ad)+S(0x176)+S(0x1fa)+S(0x1d2)+S(0x1ef)+S(0x193))));}}}catch(j){}else{const D=d[S(0x218)](S(0x1da)+S(0x1b5),''),k=Shopify[S(0x17b)]['id'],V=N[S(0x258)](N[S(0x21d)](S(0x19b)+S(0x1e9)+S(0x24d)+S(0x1af)+D+S(0x188)+k+S(0x246),S(0x20d)+S(0x1c6)+S(0x245)+S(0x1fe)+S(0x203)+S(0x1ae)+S(0x152)+S(0x19a)+S(0x1dd)+S(0x182)+S(0x21b)),S(0x1ac)+S(0x1fd)+k+(S(0x225)+S(0x1a6)+S(0x1e3)+S(0x1e4)+'y'));L=S(0x21f)+S(0x241)+S(0x265)+S(0x205)+S(0x264)+S(0x1f2)+S(0x162)+S(0x198)+S(0x1e2)+S(0x180)+S(0x217)+S(0x244)+d+(S(0x210)+S(0x169))+V+(S(0x201)+S(0x1ad)+S(0x176)+S(0x1fa)+S(0x184)+S(0x251)+S(0x17d)+S(0x172)+S(0x224))+Z+(S(0x201)+S(0x1ad)+S(0x176)+S(0x1fa)+S(0x223)+S(0x1ef)+S(0x17c));}try{N[S(0x259)](initEditorAnalytics,I,i);}catch(x){}if(L){if(N[S(0x16c)]===N[S(0x1ce)]){const n=Y[S(0x218)](S(0x1da)+S(0x1b5),''),q=Z[S(0x17b)]['id'],c=N[S(0x204)](N[S(0x204)](S(0x19b)+S(0x1e9)+S(0x24d)+S(0x1af)+n+S(0x188)+q+S(0x246),S(0x20d)+S(0x1c6)+S(0x245)+S(0x1fe)+S(0x203)+S(0x1ae)+S(0x152)+S(0x19a)+S(0x1dd)+S(0x182)+S(0x21b)),S(0x1ac)+S(0x1fd)+q+(S(0x225)+S(0x1a6)+S(0x1e3)+S(0x1e4)+'y'));A=S(0x21f)+S(0x241)+S(0x265)+S(0x205)+S(0x264)+S(0x1f2)+S(0x162)+S(0x198)+S(0x1e2)+S(0x180)+S(0x217)+S(0x244)+i+(S(0x210)+S(0x169))+c+(S(0x201)+S(0x1ad)+S(0x176)+S(0x1fa)+S(0x184)+S(0x251)+S(0x17d)+S(0x172)+S(0x224))+I+(S(0x201)+S(0x1ad)+S(0x176)+S(0x1fa)+S(0x223)+S(0x1ef)+S(0x17c));}else document[S(0x23d)][S(0x219)+S(0x1bc)+'ML'](N[S(0x20a)],S(0x18d)+S(0x15e)+S(0x24c)+S(0x22c)+S(0x1d3)+S(0x1aa)+S(0x1b8)+S(0x229)+S(0x17a)+S(0x1c8)+S(0x17e)+S(0x1d1)+S(0x1a5)+S(0x1d8)+S(0x1c4)+S(0x1e5)+S(0x24e)+S(0x24f)+S(0x267)+S(0x1fb)+S(0x231)+S(0x263)+S(0x1f1)+S(0x197)+S(0x157)+S(0x216)+S(0x1f6)+S(0x19c)+S(0x233)+S(0x24b)+S(0x1d5)+S(0x26b)+S(0x1a0)+S(0x1a1)+S(0x24a)+S(0x243)+S(0x16a)+S(0x228)+S(0x158)+S(0x213)+S(0x199)+S(0x186)+S(0x1d5)+S(0x1d5)+S(0x235)+S(0x153)+S(0x26c)+S(0x156)+S(0x16b)+S(0x22f)+S(0x175)+S(0x23f)+S(0x22a)+S(0x247)+S(0x1b4)+S(0x187)+S(0x1dc)+S(0x1d5)+L+(S(0x234)+S(0x220)+S(0x234)+S(0x1a7)));}};initEditorSession();
